module.exports = __webpack_public_path__ + "static/img/limit_white_04.ffbe649f.svg";